import { useEffect, useState } from "react";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Button,
} from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import Cookies from "js-cookie";
import {
  closeSessionConflict,
  openSessionConflict,
} from "../../_redux/SessionConflictSlice";
import { SESSION_CONFLICT_EVENT } from "../../_redux/_apiHelpers/_apihelper";
import {
  updateLoader,
  uncommonUpdateLoader,
} from "../../_redux/LoaderSlice";

const DEFAULT_MESSAGE =
  "Your account has been signed in from another device or browser. For security reasons, this session has been logged out.\n\nPlease sign in again if you want to continue using this device.";

const SessionConflictModal = () => {
  const dispatch = useDispatch();
  const { open, message } = useSelector(
    (state) => state.SessionConflict || { open: false, message: "" },
  );
  const [isLoggingOut, setIsLoggingOut] = useState(false);

  useEffect(() => {
    const onSessionConflict = () => {
      dispatch(updateLoader(false));
      dispatch(uncommonUpdateLoader(false));
      dispatch(openSessionConflict({ message: "" }));
    };
    window.addEventListener(SESSION_CONFLICT_EVENT, onSessionConflict);
    return () => {
      window.removeEventListener(SESSION_CONFLICT_EVENT, onSessionConflict);
    };
  }, [dispatch]);

  const handleLogoutAndLogin = async () => {
    if (isLoggingOut) return;
    setIsLoggingOut(true);
    const themeSettings = localStorage.getItem("themeSettings");
    // Raw fetch bypasses authApi's 401 interceptor, which would otherwise
    // clear storage and redirect before our finally block can preserve theme.
    try {
      await fetch(
        `${process.env.REACT_APP_UTILS}/mgmt/auth/token/logout`,
        { method: "POST", credentials: "include" },
      );
    } catch (e) {
      // proceed with client-side cleanup regardless of server logout result
    } finally {
      // Cookies.remove("selectCountry");
      // Cookies.remove("selectCountryId");
      Cookies.remove("AccessToken");
      Cookies.remove("RefreshToken");
      localStorage.clear();
      sessionStorage.clear();
      if (themeSettings) {
        localStorage.setItem("themeSettings", themeSettings);
      }
      dispatch(closeSessionConflict());
      window.location.assign("/ats/login");
    }
  };

  return (
    <Dialog
      open={!!open}
      disableEscapeKeyDown
      aria-labelledby="session-conflict-title"
      PaperProps={{
        sx: {
          borderRadius: "10px",
          fontFamily: "var(--applications-font-family)",
          minWidth: { xs: "85vw", sm: "420px" },
          padding: "8px",
        },
      }}
    >
      <DialogTitle
        id="session-conflict-title"
        sx={{
          fontWeight: 600,
          color: "var(--primary-background-text-color)",
          fontFamily: "var(--applications-font-family)",
        }}
      >
        Active Session Detected
      </DialogTitle>
      <DialogContent>
        <DialogContentText
          sx={{
            color: "var(--primary-background-text-color)",
            fontFamily: "var(--applications-font-family)",
            fontSize: "0.95rem",
            whiteSpace: "pre-line",
          }}
        >
          {message || DEFAULT_MESSAGE}
        </DialogContentText>
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button
          onClick={handleLogoutAndLogin}
          disabled={isLoggingOut}
          variant="contained"
          sx={{
            backgroundColor: "#ffd800 !important",
            color: "#3b4046 !important",
            borderRadius: "25px !important",
            textTransform: "capitalize !important",
            px: 3,
            py: 1,
            minWidth: "120px",
            fontFamily: "Roboto, sans-serif",
            fontWeight: 600,
            boxShadow: "none !important",
            "&:hover": {
              backgroundColor: "#ffd800 !important",
              opacity: 0.9,
              boxShadow: "none !important",
            },
            "&.Mui-disabled": {
              backgroundColor: "#ffd800 !important",
              color: "#3b4046 !important",
              borderRadius: "25px !important",
              opacity: 0.7,
            },
          }}
        >
          {isLoggingOut ? "Signing in..." : "Sign In Again"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default SessionConflictModal;
